import { useCallback, useEffect, useState } from 'react';
import { hasBirthDate } from '../services/profile';

export type GateStatus = 'loading' | 'needed' | 'done';

/**
 * Décide si l'étape post-auth « date de naissance » doit s'afficher : une fois connecté, on
 * vérifie si la date est déjà renseignée. `dismiss` marque l'étape faite pour CETTE session
 * (skip ou complétion) — si l'utilisateur skippe, on redemandera au prochain lancement.
 * En cas d'erreur de lecture, on n'empêche jamais l'entrée dans l'app ('done').
 */
export function useBirthDateGate(hasSession: boolean) {
  const [status, setStatus] = useState<GateStatus>('loading');

  useEffect(() => {
    if (!hasSession) {
      setStatus('loading');
      return;
    }
    let active = true;
    hasBirthDate()
      .then((has) => active && setStatus(has ? 'done' : 'needed'))
      .catch(() => active && setStatus('done'));
    return () => {
      active = false;
    };
  }, [hasSession]);

  const dismiss = useCallback(() => setStatus('done'), []);

  return { status, dismiss };
}
